import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useButtonSizeStyle } from "../internal/InternalButton";
import { useFullTheme } from "../design";
import { useResponsive } from "./";
export function useSelectStyling(_ref) {
  var _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? 'highlighted' : _ref$emphasis,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'secondary' : _ref$intent,
    _ref$invalid = _ref.invalid,
    invalid = _ref$invalid === void 0 ? false : _ref$invalid,
    selectedOptionIntent = _ref.selectedOptionIntent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size;
  var theme = useFullTheme();
  var adjustedIntent = invalid ? 'negative' : intent;
  var responsive = useResponsive();
  var outlineColor = {
    magic: theme.colors.actionMagic,
    negative: theme.colors.actionNegative,
    positive: theme.colors.actionPositive,
    primary: theme.colors.actionPrimary,
    secondary: theme.colors.actionPrimary,
    // actionPrimary color used intentionally for secondary intent
    warning: theme.colors.actionWarning
  }[adjustedIntent];
  var sizeStyle = useButtonSizeStyle({
    size: size
  });
  var highlightedBg = {
    "default": {
      magic: theme.colors.bgMagicHighlight,
      negative: theme.colors.bgNegativeHighlight,
      positive: theme.colors.bgPositiveHighlight,
      primary: theme.colors.bgPrimaryHighlight,
      secondary: theme.colors.bgSecondaryHighlight,
      warning: theme.colors.bgWarningHighlight
    },
    hover: {
      magic: theme.colors.bgMagicHighlightHover,
      negative: theme.colors.bgNegativeHighlightHover,
      positive: theme.colors.bgPositiveHighlightHover,
      primary: theme.colors.bgPrimaryHighlightHover,
      secondary: theme.colors.bgSecondaryHighlightHover,
      warning: theme.colors.bgWarningHighlightHover
    },
    active: {
      magic: theme.colors.bgMagicHighlightPressed,
      negative: theme.colors.bgNegativeHighlightPressed,
      positive: theme.colors.bgPositiveHighlightPressed,
      primary: theme.colors.bgPrimaryHighlightPressed,
      secondary: theme.colors.bgSecondaryHighlightPressed,
      warning: theme.colors.bgWarningHighlightPressed
    }
  };
  var emphasisStyle = {
    highlighted: _objectSpread(_objectSpread({}, theme.borders.transparent), {}, {
      backgroundColor: highlightedBg["default"][adjustedIntent],
      '&:enabled:hover': {
        backgroundColor: highlightedBg.hover[adjustedIntent]
      },
      '&:enabled:active': {
        backgroundColor: highlightedBg.active[adjustedIntent]
      }
    }),
    outlined: _objectSpread(_objectSpread({}, theme.borders[intent]), {}, {
      backgroundColor: _objectSpread(_objectSpread({}, highlightedBg["default"]), {}, {
        secondary: theme.colors.bgRegular
      })[adjustedIntent],
      '&:enabled:hover': {
        backgroundColor: _objectSpread(_objectSpread({}, highlightedBg.hover), {}, {
          secondary: theme.colors.bgRegularHover
        })[adjustedIntent]
      },
      '&:enabled:active': {
        backgroundColor: _objectSpread(_objectSpread({}, highlightedBg.active), {}, {
          secondary: theme.colors.bgRegularPressed
        })[adjustedIntent]
      }
    })
  }[emphasis];
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    alignItems: 'center',
    appearance: 'none',
    borderRadius: theme.borderRadiuses.control,
    color: selectedOptionIntent ? {
      magic: theme.colors.textMagic,
      negative: theme.colors.textNegative,
      positive: theme.colors.textPositive,
      primary: theme.colors.textPrimary,
      secondary: theme.colors.textSecondary,
      warning: theme.colors.textWarning
    }[selectedOptionIntent] : {
      magic: theme.colors.textMagicStark,
      negative: theme.colors.textNegativeStark,
      positive: theme.colors.textPositiveStark,
      primary: theme.colors.textPrimaryStark,
      secondary: theme.colors.textSecondaryStark,
      warning: theme.colors.textWarningStark
    }[adjustedIntent],
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'left',
    textWrap: 'nowrap'
  }, responsive.css(theme.typography.bodyS)), {}, {
    '&:hover': {
      backgroundColor: {
        magic: theme.colors.bgMagicHighlightHover,
        negative: theme.colors.bgNegativeHighlightHover,
        positive: theme.colors.bgPositiveHighlightHover,
        primary: theme.colors.bgPrimaryHighlightHover,
        secondary: theme.colors.bgSecondaryHighlightHover,
        warning: theme.colors.bgWarningHighlightHover
      }[adjustedIntent]
    },
    '&:active': {
      backgroundColor: {
        magic: theme.colors.bgMagicHighlightPressed,
        negative: theme.colors.bgNegativeHighlightPressed,
        positive: theme.colors.bgPositiveHighlightPressed,
        primary: theme.colors.bgPrimaryHighlightPressed,
        secondary: theme.colors.bgSecondaryHighlightPressed,
        warning: theme.colors.bgWarningHighlightPressed
      }[adjustedIntent]
    },
    '&:focus-within': {
      outline: "2px solid ".concat(outlineColor)
    },
    '&[disabled],&[aria-disabled="true"]': _objectSpread({
      backgroundColor: theme.colors.bgInactive,
      color: theme.colors.textInactive,
      cursor: 'not-allowed',
      opacity: 0.7
    }, emphasis === 'highlighted' ? {} : {
      borderStyle: 'none'
    }),
    // TODO: remove this when all selects allow focusing when disabled:
    '&[disabled]': {
      outline: 'none'
    }
  }, sizeStyle), emphasisStyle), {}, {
    width: 'unset'
  });
}